import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjNewRequirement"
});
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.76179 2.07104C4.48565 2.07104 4.26179 2.2949 4.26179 2.57105V10.2045H1.68532V13.4288C1.68532 13.7049 1.90918 13.9288 2.18532 13.9288H14.8228C15.0989 13.9288 15.3228 13.7049 15.3228 13.4288V10.2045H12.7463L15.3191 10.2044L14.2142 4.5498C14.1959 4.4559 14.1136 4.38815 14.018 4.38815H12.7463V2.57104C12.7463 2.2949 12.5225 2.07104 12.2463 2.07104H4.76179ZM11.3612 3.65612C11.3612 3.54566 11.2717 3.45612 11.1612 3.45612H5.84687C5.73641 3.45612 5.64687 3.54566 5.64687 3.65612V9.19131C5.64649 9.20361 5.92014 9.20162 6.1495 9.19779C6.31823 9.19497 6.45517 9.33126 6.47999 9.49817C6.62776 10.492 7.47877 11.2993 8.50401 11.2993C9.53158 11.2993 10.3876 10.5045 10.5331 9.51048C10.5572 9.34632 10.6895 9.21118 10.8555 9.20997C11.0848 9.2083 11.3616 9.20371 11.3612 9.19131V3.65612ZM13.7666 8.92589H12.7463V5.66668H13.1298L13.7666 8.92589Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M4.26123 4.38815H2.9828C2.88713 4.38815 2.80486 4.4559 2.78651 4.5498L1.68164 10.2044L4.26179 10.2045L4.26123 8.92589H3.23417L3.87099 5.66668H4.26123V4.38815Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M6.48633 6.38339C6.48633 6.27293 6.57587 6.18339 6.68633 6.18339H7.79654V5.07305C7.79654 4.96259 7.88609 4.87305 7.99654 4.87305H9.00395C9.11441 4.87305 9.20395 4.96259 9.20395 5.07305V6.18339H10.3144C10.4249 6.18339 10.5144 6.27293 10.5144 6.38339V7.3908C10.5144 7.50125 10.4249 7.5908 10.3144 7.5908H9.20395L9.20395 8.70113C9.20395 8.81159 9.11441 8.90113 9.00395 8.90113H7.99654C7.88609 8.90113 7.79654 8.81159 7.79654 8.70113L7.79654 7.5908H6.68633C6.57587 7.5908 6.48633 7.50125 6.48633 7.39079V6.38339Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var SJ__New_requirement = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ__New_requirement as default };
